import { useState, useEffect } from "react";

export default function DashboardFooter() {
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

  // Mettre à jour l'année automatiquement si nécessaire
  useEffect(() => {
    setCurrentYear(new Date().getFullYear());
  }, []);

  return (
    <footer className="bg-[#fefaf6] border-t border-gray-200 py-4 mt-auto">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="text-center text-sm text-gray-600">
            © {currentYear} <span className="text-orange-500 font-bold">Guide</span>
            <span className="text-green-600 font-bold">Pro </span> 
            - Tous droits réservés | Ministère de la Fonction Publique et de la Modernisation de l'Administration
          </div>
          
          <div className="flex space-x-4 mt-2 md:mt-0">
            <a href="/mentions-legales" className="text-sm text-gray-600 hover:text-orange-500">
              Mentions légales
            </a>
            <a href="/confidentialite" className="text-sm text-gray-600 hover:text-orange-500">
              Confidentialité
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
} 